import React, { Component } from 'react';
import { message } from 'antd';
import { base } from '../../base';
import MachineManagersView from '../views/MachineManagersView';

class MachineManagersContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contacts: [],
        };
    }

    handleLogDelete = (id) => {
        console.log(id);
        const extraUser = this.props.extraUser;
        base.remove(`contacts/${this.props.extraUser.companyid}/${id}`, function (err) {
            if (!err) {
                message.success('Contacto Eliminado');
            }
        });
    }

    componentWillMount() {
        this.valuesRef = base.syncState(`contacts/${this.props.extraUser.companyid}/`, {
            context: this,
            state: 'contacts',
            asArray: true,
            queries: {
                orderByChild: 'machineid',
                equalTo: this.props.machineId,
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        return (
            <MachineManagersView
                deleteLog={this.handleLogDelete}
                machineId={this.props.machineId}
                user={this.props.user}
                extraUser={this.props.extraUser}
                managers={this.state.contacts}
            />
        );
    }
}
export default MachineManagersContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineManagersContainer.js